module.exports = __webpack_public_path__ + "img/ប្រដាល់.54287d2e.png";